<template>
  <app-button
    classes="btn btn-green"
    :class="downloadAllowed ? '' : 'btn-disabled'"
    @click.native="downloadPdf"
    text="Download Now"
    :disabled="!downloadAllowed"
  />
</template>

<script>
import { mergePdf } from "../../helpers/mergePdf.js";
import { mapActions, mapState } from "vuex";

export default {
  name: "home-page",
  components: {
    "app-button": () => import("@/components/Shared/AppButton"),
  },
  props: {
    productName: String,
    productUrl: String,
    localOrder: Object,
    hasTemporaryLicense: Boolean,
    cobrandFields: Array,
  },
  data() {
    return {
      available: true,
    };
  },
  computed: {
    ...mapState({ pdf: (state) => state.pdf }),
    orderFor() {
      if (this.localOrder == undefined) return;

      if (this.localOrder?.orderedFor?.employeeNumber) {
        return this.localOrder.orderedFor.employeeNumber;
      } else return null;
    },
    allCobrandFieldsPopulated() {
      return Object.keys(this.localOrder?.cobrandInstantFields || {}).every(
        (key) => !!this.localOrder?.cobrandInstantFields[key]
      );
    },
    downloadAllowed() {
      return this.pdf.lo?.nmls &&
        this.available &&
        !this.hasTemporaryLicense &&
        ((this.cobrandFields[0]?.value === "No" &&
          this.localOrder.orderedFor) ||
          (this.cobrandFields[0]?.value === "Yes" &&
            this.localOrder.cobrandInstantFields &&
            this.allCobrandFieldsPopulated))
        ? true
        : false;
    },
  },
  methods: {
    ...mapActions([
      "setProductName",
      "setFlyerUrl",
      "setPdfInfo",
      "createOrder",
      "setPartnerInfo",
    ]),
    async downloadPdf() {
      const delObj = {
        id: null,
        filepath: this.productUrl,
        status: "final",
      };
      this.localOrder.deliverables.push(delObj);
      this.localOrder.status = "Completed";

      if (this.allCobrandFieldsPopulated) {
        this.setPartnerInfo(this.localOrder.cobrandInstantFields);
      }

      await this.createOrder(this.localOrder);
      await mergePdf({ data: this.pdf, position: { x: 0, y: 635 } });
    },
  },
  watch: {
    async orderFor() {
      // If orderFor Changes, Update PDF State Info
      if (this.orderFor != undefined) {
        this.available = true;
        this.setPdfInfo(this.orderFor);
        return;
      }
      this.available = false;
    },
  },
  mounted() {
    // Set PDF Info When Mounted
    this.setFlyerUrl(this.productUrl);
    this.setProductName(this.productName);
    this.setPdfInfo(this.orderFor);
  },
};
</script>
